function selectOutrosKitsLadderProduct(productId) {
  if (typeof window.selectBundleLadderProduct === 'function') {
    return window.selectBundleLadderProduct(productId);
  }

  const targetId = String(productId);
  let selected = false;

  document.querySelectorAll('[data-product-bundle-ladder]').forEach((root) => {
    const radio = Array.from(root.querySelectorAll('[data-bundle-radio]')).find(
      (el) => el.dataset.productId === targetId
    );
    if (!radio || radio.disabled) return;

    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));

    root.querySelectorAll('[data-bundle-option]').forEach((option) => {
      option.classList.toggle('is-selected', option.contains(radio));
    });

    selected = true;
  });

  return selected;
}

function initOutrosKits(scope = document) {
  scope.querySelectorAll('[data-outros-kits]').forEach((root) => {
    if (root.dataset.outrosKitsInitialized === 'true') return;
    root.dataset.outrosKitsInitialized = 'true';

    root.querySelectorAll('[data-bundle-kit-select]').forEach((button) => {
      button.addEventListener('click', () => {
        selectOutrosKitsLadderProduct(button.dataset.productId);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initOutrosKits());
} else {
  initOutrosKits();
}

document.addEventListener('shopify:section:load', (event) => {
  initOutrosKits(event.target);
});
